import React from 'react';
import { Alert, AlertIcon, AlertTitle } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { EWORK_DEMANDE_STATUS } from 'Constaints';

/**
 * EworkDemandStatusAlert Component
 * Displays the e-work demand status with appropriate alert styling
 *
 * @param {Object} props - Component props
 * @param {string} props.eworkStatus - The e-work status value to display
 * @param {string} props.className - Optional CSS classes
 * @returns {JSX.Element|null} Alert component or null if no status
 */
const EworkDemandStatusAlert = ({ eworkStatus, className = 'mb-5 rounded-lg shadow' }) => {
  const { t } = useTranslation('add_contract');

  // Return null if no valid status provided
  if (eworkStatus === undefined || eworkStatus === null) {
    return null;
  }

  /**
   * Determine alert status based on eworkStatus
   * Success statuses: RQ_EWORKPERMIT, RQ_VERIFIED, RQ_INCOMPLETED, RQ_PICKED
   * Warning statuses: All other statuses
   */
  const getAlertStatus = (status) => {
    const successStatuses = [
      EWORK_DEMANDE_STATUS.RQ_EWORKPERMIT.value,
      EWORK_DEMANDE_STATUS.RQ_VERIFIED.value,
      EWORK_DEMANDE_STATUS.RQ_INCOMPLETED.value,
      EWORK_DEMANDE_STATUS.RQ_PICKED.value,
    ];

    return successStatuses.includes(status) ? 'success' : 'warning';
  };

  /**
   * Get the label for the given status
   */
  const getStatusLabel = (status) => {
    const statusObj = Object.values(EWORK_DEMANDE_STATUS).find((s) => s.value === status);
    return statusObj?.label || 'Unknown Status';
  };

  return (
    <Alert className={className} status={getAlertStatus(eworkStatus)}>
      <AlertIcon />
      <AlertTitle>
        {t('demand_status_message', {
          status: getStatusLabel(eworkStatus),
        })}
      </AlertTitle>
    </Alert>
  );
};

export default EworkDemandStatusAlert;
